import cookies from './util.cookies';
import log from './util.log';
import db from './util.db';
import validators from './util.validators';
import tool from './util.tool.v1';
import component from './util.component.js';
import { staticUrl } from '@/api';
import time from './util.time';
import Setting from '@/setting.ht';
import './util.number';
var util = {
  cookies: cookies,
  log: log,
  db: db,
  validators: validators,
  tool: tool,
  component: component,
  time: time
};

function tTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (window && window.$t) {
    if (title.indexOf('$t:') === 0) {
      return window.$t(title.split('$t:')[1]);
    } else {
      return title;
    }
  } else {
    return title;
  }
}
/**
 * @description 更改标题
 * @param {Object} title 标题
 * @param {Object} count 未读消息数提示（可视情况选择使用或不使用）
 */


util.title = function (_ref) {
  var title = _ref.title,
      count = _ref.count;
  title = tTitle(title);
  var fullTitle = title ? "".concat(title, " - ").concat(Setting.titleSuffix) : Setting.titleSuffix;
  if (count) fullTitle = "(".concat(count, "\u6761\u6D88\u606F)").concat(fullTitle);
  window.document.title = fullTitle;
};

util.downLoadReName = function (downUrl, modeNameZh, YMD, suffix) {
  var date = new Date();

  if (YMD === 'YMD') {
    YMD = "".concat(date.getFullYear()).concat(date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)).concat(date.getDate() > 9 ? date.getDate() : '0' + date.getDate());
  }

  var filename = "".concat(modeNameZh).concat(YMD, ".").concat(suffix);
  var uploadUrl = "".concat(staticUrl(DYC_URL.common_download_rename), "?netAddress=").concat(downUrl.toString(), "&filename=").concat(filename);
  var a = document.createElement('a');
  a.setAttribute('download', ''); // download属性

  a.setAttribute('href', uploadUrl); // href链接

  a.click();
};

function requestAnimation(task) {
  if ('requestAnimationFrame' in window) {
    return window.requestAnimationFrame(task);
  }

  setTimeout(task, 16);
}

export { requestAnimation };
export default util;